import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';
import type { FilterKey } from '@core/Entities/Search/QueryParams.entity';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { createPathFromFilters } from '@core/Utils/Search/CreatePathFromFilters';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';

import { applyFilterChanges } from './ApplyFiltersChange';

/**
 * Given a list of filters and a filter ID -
 * returns a function that creates a link for a single filter value.
 * If a filter value is already selected, the link will remove it.
 * Inversely, if a filter value is not selected, the link will add it.
 */
export const createFiltersLinkForFilterValue = ({
  filters,
  filterId,
  root,
  tenant,
}: {
  filters: Filter[];
  filterId: FilterKey;
  root: PlpRoot;
  tenant: Tenant | undefined;
}) => {
  const filter = getFilterFromArray(filterId, filters);
  const selectedOptions = new Set(filter?.value ?? []);
  return (value: string) => {
    const selected = new Set(selectedOptions);
    if (!selected.has(value)) {
      selected.add(value);
    } else {
      selected.delete(value);
    }
    const filterValue = Array.from(selected);
    const newFilters = applyFilterChanges(filters, [
      {
        id: filterId,
        value: filterValue,
      },
    ]);
    const path = createPathFromFilters(newFilters ?? [], root);
    if (!tenant) return path;

    return path;
  };
};
